import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ShowBlogs from "./Components/ShowBlogs";
import MyStats from "./Components/MyStats";
const API_HOST = process.env.REACT_APP_API_URL;

function AdminBlogs() {
  const navigate = useNavigate();
  const [adminName, setAdminName] = useState("Admin");
  const [showStats, setShowStats] = useState(false);

  // Function to fetch current user's name from the backend
  async function getCurrentUserName() {
    const authToken = sessionStorage.getItem("authToken");

    if (!authToken) {
      console.error("No auth token found in sessionStorage.");
      return null;
    }

    try {
      
      const response = await fetch(`${API_HOST}auth/getuser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": authToken,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const userData = await response.json();
      return userData.name;
    } catch (error) {
      console.error("Failed to fetch user:", error);
      return null;
    }
  }

  useEffect(() => {
    const checkAndFetchUser = async () => {
      const authToken = sessionStorage.getItem("authToken");
      const userType = sessionStorage.getItem("userType");

      if (!authToken || !userType || userType !== "blogger") {
        navigate("/blogger/login");
        return;
      }

      const name = await getCurrentUserName();
      if (name) {
        setAdminName(name);
      }
    };

    checkAndFetchUser();
  }, [navigate]);

  return (
    <>
      <div className="admin-dashboard-container container">
        <div className="dashboard-header">
          <h1>Welcome, {adminName}</h1>
          <div
            className="flex justify-content-between"
            style={{
              padding: "8px",
              display: "flex",
              gap: "10px",
            }}
          >
            <button className="logout-button" onClick={() => navigate("/blogger/blogs/create")}>
              <b>Create Blog</b>
            </button>

            <button
              className="logout-button"
              onClick={() => setShowStats(!showStats)}
            >
              {showStats ? "Hide Stats" : "Show Stats"}
            </button>

            <button
              onClick={() => {
                sessionStorage.removeItem("authToken");
                sessionStorage.removeItem("userType");
                navigate("/admin/login");
              }}
              className="logout-button"
            >
              Logout
            </button>
          </div>
        </div>

        {showStats && <MyStats />}

        <ShowBlogs />
      </div>
    </>
  );
}

export default AdminBlogs;
